import React from 'react';
import { useForm, ObservableField } from '../../ObservableForm';
import { InputFieldFragment } from './InputField.generated';
import Text from '../../Text';

export type Props = InputFieldFragment;

export function Edit({ id, label, required, placeholder, description, helperText }: Props) {
    const form = useForm();

    return (
        <ObservableField
            form={form}
            name={id}
            title={label}
            message={description ?? ''}
            tooltip={helperText ? helperText : undefined}
            required={required ?? false}
            render={() => <Text placeholder={placeholder} fill {...form.attach(id)} />}
        />
    );
}

export function View({ inputValue }: Props) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return inputValue ? <>{inputValue}</> : null;
}

export function HasValue({ inputValue }: Props): boolean {
    return inputValue !== '';
}

export function getValue({ inputValue }: Props) {
    return inputValue;
}
